import { Injectable } from 'angular-ts-decorators';

import {
  SessionObject,
  ITenantApplication,
} from '@shared/app/scripts/classes/session-object';
export { SessionObject };

import { find } from 'lodash';
import { Observable, Subject } from 'rxjs';

/**
 * Service that expose current session information. It updated by {@link
 * sharedModule.session#current session} service. Created to avoid circular
 * dependencies.
 *
 * Inherits fields form {@link sharedModule.SessionObject SessionObject} class
 */
@Injectable('currentSession')
export class CurrentSession extends SessionObject {
  /**
   * Stream that emits all expected tenantId changes
   */
  public tenantId$: Observable<string>;
  private tenantIdSubject: Subject<string>;

  /**
   * Stream that emits all expected sid changes
   */
  public sid$: Observable<string>;
  private sidSubject: Subject<string>;

  constructor() {
    'ngInject';

    super();

    this.sidSubject = new Subject<string>();
    this.sid$ = this.sidSubject.asObservable();

    this.tenantIdSubject = new Subject<string>();
    this.tenantId$ = this.tenantIdSubject.asObservable();

    this.username = undefined;
    this.userId = undefined;
    this.email = undefined;
    this.tenantId = undefined;
    this.wholesale = false;
    this.retail = false;
    this.roles = {};
    this.fullname = undefined;
    this.tz = undefined;
    this.sid = undefined;
    this.language = undefined;
    this.isLogged = false;
    this.availableTenants = [];
    this.applications = {};
    this.deviceId = undefined;
    this.warehouse = undefined;
    this.type = undefined;
    this.acls = {};
    this.reportAcls = {};
    this.favorites = {};
    this.email_verify_pending = undefined;
    this.countryCode = undefined;
  }

  /**
   * Empty the current session
   * @return {Void}
   * Nothing
   */
  empty() {
    this.sidSubject.next(undefined);
    this.tenantIdSubject.next(undefined);

    this.username = undefined;
    this.isLogged = false;
    this.userId = undefined;
    this.email = undefined;
    this.tenantId = undefined;
    this.wholesale = false;
    this.retail = false;
    this.roles = {};
    this.fullname = undefined;
    this.tz = undefined;
    this.sid = undefined;
    this.language = undefined;
    this.roles = {};
    this.availableTenants = [];
    this.applications = {};
    this.deviceId = undefined;
    this.warehouse = undefined;
    this.type = undefined;
    this.acls = {};
    this.reportAcls = {};
    this.favorites = {};
    this.email_verify_pending = undefined;
    this.countryCode = undefined;
  }

  /**
   * @param {object} current values we want to set
   * @param {string} sid session id
   * Set the values to the provided /me response
   * @return {Void}
   * Nothing
   */
  setTo(current: any, sid: string) {
    this.sidSubject.next(sid);
    this.tenantIdSubject.next(current.current_tenant);

    // custom(ized) fields
    this.isLogged = true;
    this.userId = current._id;
    this.warehouse = current.wh;
    this.availableTenants = current.tenants;
    this.tenantId = current.current_tenant;
    this.reportAcls = current.reportacls;
    this.countryCode = current.countryCode;

    let tenant = <ITenantApplication>(
      find(this.availableTenants, { id: current.current_tenant })
    );

    if (tenant) {
      this.wholesale = tenant.wholesale;
      this.retail = tenant.retail;
    } else {
      this.wholesale = false;
      this.retail = false;
    }

    // copied fields
    this.username = current.username;
    this.email = current.email;
    this.fullname = current.fullname;
    this.tz = current.tz;
    this.sid = sid;
    this.language = current.language;
    this.roles = current.roles;
    this.applications = current.applications;
    this.deviceId = current.deviceId;
    this.type = current.type;
    this.acls = current.acls;
    this.favorites = current.favorites;
    this.email_verify_pending = current.email_verify_pending;
  }
}
